/** North America-centered space view. Home enters rotation mode from here. */
export const HOME_LONGITUDE_DEG = -98.5795;
export const HOME_LATITUDE_DEG = 39.8283;
/** Full disk with atmosphere, not a street-level start. */
export const HOME_HEIGHT_METERS = 18_000_000;
